import {StateProvider} from "@uirouter/angularjs";
import {FeatureNames, UserConfigProvider} from "../../types/UserConfig";
import {DashboardView} from "../oms/view/DashboardViewComponent";
import {Branding} from "../../types/Branding";

export function calculatePageTitle(branding: Branding): string {
    switch (branding) {
        case Branding.OPEN_MARKETS:
            return "OpenMarkets";
        case Branding.OPEN_TRADER:
            return "Opentrader";
        case Branding.BELLMONT:
            return "Bellmont Securities";
        case Branding.FUTURE_ASSIST:
            return "Future Assist";
        case Branding.ALLFIN:
            return "Allfin";
        case Branding.SUUBEE:
            return "Suubee Premium";
        case Branding.LIQUIDITY:
            return "Liquidity";
        default:
            return "OpenMarkets";
    }
}

export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    const pageTitle = calculatePageTitle(userConfigProvider.config.branding);

    const hasAdviserScreen = userConfigProvider.config.features[FeatureNames.SCREEN_ADVISER_DASHBOARD];
    const hasClearingDashboardScreen = userConfigProvider.config.features[FeatureNames.CLEARING_DASHBOARD];

    if (hasAdviserScreen) {
        $stateProvider.state("home", {
            url: "/?view",
            component: DashboardView,
            data: {
                pageTitle
            },
            params: {
                view: {
                    dynamic: true,
                    type: "int",
                    isOptional: true,
                    value: 1
                }
            }
        });
    } else if (userConfigProvider.config.client) {
        $stateProvider.state("home", {
            url: "/",
            templateUrl: "app/tradeon/tradeon.tpl.html",
            controller: "tradeOnCtrl as tradeOn",
            data: {
                pageTitle
            }
        });
    } else {
         if (userConfigProvider.config.adviser) {
            // advisers get this screen so they can see exercised activity
            $stateProvider.state("home", {
                url: "/",
                templateUrl: "app/home/home.tpl.html",
                controller: "homeCtrl as home",
                data: {
                    pageTitle
                }
            });
        } else if (hasClearingDashboardScreen) {
            $stateProvider.state("home", {
                url: "/",
                redirectTo: "risk-dashboard"
            });
        } else {
            $stateProvider.state("home", {
                url: "/",
                templateUrl: "app/home/home.tpl.html",
                controller: "homeCtrl as home",
                data: {
                    pageTitle
                }
            });
        }
    }
}
